<template>
  <div>
    <transition
      name="fade"
      mode="out-in">
      <initial-cookie-popup
        v-if="isSmallPopupVisible"
        :is-e-u="isEU"
        @accept-all="acceptAll"
        @close="close"
        @manage-cookies="showManageCookies" />

      <manage-cookies
        v-else
        @accept-all="acceptAll"
        @save-preferences="savePreferences" />
    </transition>
  </div>
</template>

<script>
import InitialCookiePopup from 'Components/Popups/cookiePopups/InitialCookiePopup.vue';
import ManageCookies from 'Components/Popups/cookiePopups/ManageCookies.vue';
import GoogleTagAnalytics from 'Root/drivers/googleTagAnalytics';
import yandexMetrika from 'Root/drivers/yandexMetrika';

export default {
  components: {
    InitialCookiePopup,
    ManageCookies,
  },

  props: {
    isEU: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isSmallPopupVisible: true,
    };
  },

  methods: {
    showManageCookies() {
      this.isSmallPopupVisible = false;
    },

    acceptAll() {
      this.$emit('accept');

      if (!this.EU) {
        return;
      }

      const consent = {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
        functionality_storage: 'granted',
        security_storage: 'granted',
      };

      if ('localStorage' in window) {
        window.localStorage.setItem('cookies-consent', JSON.stringify(consent));
      }

      GoogleTagAnalytics.updateConsent(consent);

      yandexMetrika.invokeEvent('dma_cookie_accept_all');
    },

    savePreferences(consent) {
      if ('localStorage' in window) {
        window.localStorage.setItem('cookies-consent', JSON.stringify(consent));
      }

      GoogleTagAnalytics.updateConsent(consent);
      this.$emit('accept');

      yandexMetrika.invokeEvent('dma_cookie_save');
    },

    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.cookie-popup {
  display: grid;
  grid-auto-flow: row;
  background-color: rgba(0, 0, 0, 0.9);
  position: fixed;
  padding: 32px;
  bottom: 40px;
  left: 40px;
  border-radius: 32px;
  z-index: #{$z-index-intercom + 1};
}

/deep/.cookie-popup__policy-link {
  color: $color--basic-white;
  cursor: pointer;
  font-weight: 700;
}

/deep/.cookie-popup__title {
  font-size: 25px;
  font-weight: 500;
}

/deep/.cookie-popup__text {
  font-size: 11px;
  font-weight: 300;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

@media screen and #{$screen-less-than-480} {
  /deep/.cookie-popup {
    position: fixed;
    padding: 32px 16px;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 32px 32px 0 0;
    max-width: 100%;
  }

  /deep/.cookie-popup__title {
    font-size: 17px;
  }

  /deep/.cookie-popup__button {
    font-size: 13px;
  }

  /deep/.cookie-popup__container-buttons {
    display: grid;
    grid-row-gap: 16px;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, 40px);
  }
}
</style>
